import React from 'react';
import { Button } from 'primereact/button';

const PrimeButton = (props) => {
    return (
        <Button {...props} />
    );
}

export default PrimeButton;
